@if (quoteRequestForm && items) {
  <div class="cipx-collection-item" *ngFor="let item of items.controls; let i = index">
    @if (i >= 1) {
      <hr class="my-4" />
    }
    <div class="flex flex-row items-center justify-between">
      <label class="text-lg">{{ getItemLabel(i) }}</label>
      @if (canRemove) {
        <button
          mat-icon-button
          type="button"
          [attr.aria-label]="'Remove ' + getItemLabel(i)"
          (click)="removeItem(i)">
          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
        </button>
      }
    </div>
    <div class="cipx-form-form-group" *ngFor="let question of questionSet.questions">
      @if (getItemGroup(i).get(question.question_code) && isVisible(question, i)) {
        <cipx-quote-request-intake-form-question-control
          [question]="question"
          [group]="getItemGroup(i)"></cipx-quote-request-intake-form-question-control>
      }
    </div>
  </div>

  @if (canAdd) {
    <div
      class="cipx-form-form-group cipx-collection-add-group"
      [class.cipx-collection-add-group-after-error]="hasValidationErrorBeforeAdd">
      <button
        mat-stroked-button
        type="button"
        class="cipx-collection-add-button"
        [attr.aria-label]="addItemLabel"
        (click)="addItem()">
        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
        <span class="cipx-collection-add-label-mobile">Add another</span>
        <span class="cipx-collection-add-label-desktop">{{ addItemLabel }}</span>
      </button>
    </div>
  }
}
